import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { DataService } from './shared/dataService';

@Component({
  selector: 'my-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'apps';
   
  public loginRequired:boolean = false;
  public errorMessage: string = "";
  navigationSubscription: any;
  public pushVersion:string = "";
  
  ngOnInit()
  {
    console.log("AppComponent OnInit");
    this.navigationSubscription = this.router.events.subscribe((e: any) => 
    {
      // If it is a NavigationEnd event re-initalise the component
      // console.log(e);
      //  if (e instanceof NavigationEnd) 
      //  { 
      //     console.log("Navigation end: "+ this.data.loginRequired);
      //     if (this.data.loginRequired)  
      //     {
      //       this.loginRequired = true;
      //       this.router.navigate(["/account"]); 
      //     }
        
      // }
    });
  }
  constructor( private router: Router , private data : DataService)
  {
     
    console.log("constructor app.components");  
   
  }
  
  OnDeviceInfo(e)
  {
    console.log(e)
    this.router.navigate(['/deviceInfo']);
  }
  OnHome()
  {
    this.router.navigate(['/']);
  }
  OnAttLog()
  {
    this.router.navigate(['/attLog']);
  }



}
